import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Autoplay, Pagination} from 'swiper';
import classNames from 'classnames';
import {validateUrl} from 'Utils/utils';
import QrCodeSVGComponent from 'Components/common/QRCodeComponents/QrCodeSVGComponent';
import 'swiper/swiper.scss';
import 'swiper/components/pagination/pagination.scss';
import {INSIGHTS_METADATA} from 'Utils/constants';
import getShortUrl from 'Data/services/getShortUrl';
import {sendPromotionEvent} from 'Utils/analytics';

const LocationPromotions = ({
    promotions,
    navigate,
    setJourneyStop,
    tenantFeatures,
    digitalSignId,
}) => {
    const [qrCodeShortUrls, setQrCodeShortUrls] = useState({});

    useEffect(
        () => {
            (async () => {
                setQrCodeShortUrls({});
                if (!promotions) {
                    return;
                }
                const validPromotions = promotions.filter(promotion =>
                    validateUrl(promotion.handOffUrl)
                );
                const responses = await Promise.all(
                    validPromotions.map(promotion => {
                        const metadata = {
                            type: INSIGHTS_METADATA.TYPES.PROMOTIONS,
                            typeId: promotion.id,
                            action: INSIGHTS_METADATA.ACTIONS.SCAN,
                            sourceDeviceId: digitalSignId,
                        };
                        return getShortUrl(promotion.handOffUrl, metadata);
                    })
                );
                const newQrCodeShortUrls = {};
                validPromotions.forEach((promotion, index) => {
                    newQrCodeShortUrls[promotion.id] = responses[index];
                });
                setQrCodeShortUrls(newQrCodeShortUrls);
            })();
        },
        [promotions]
    );

    return (
        <div className="content-promotions glass-panel">
            <Swiper
                slidesPerView={1}
                autoplay={{
                    delay: 5000,
                }}
                loop={promotions.length > 1}
                direction="horizontal"
                modules={[Pagination, Autoplay]}
                pagination={{el: '.promo-pagination'}}
                className="swiper"
            >
                {promotions.map(promotion => (
                    <SwiperSlide key={promotion.id}>
                        <div
                            className="content-body-img"
                            onClick={() => {
                                navigate('promotionsDetailsCard', {item: promotion});
                                sendPromotionEvent('Select Promotion', promotion.title);
                                const feature = tenantFeatures.find(
                                    f => f.properties.tenant.uuid === promotion.tenantId
                                );
                                if (feature) {
                                    setJourneyStop({index: 1, feature, zoomToResult: true});
                                }
                            }}
                        >
                            {!!qrCodeShortUrls[promotion.id] && (
                                <div
                                    className={`qr-code-container align-${promotion.alignment
                                        .replace(' ', '-')
                                        .toLowerCase()} txt-light`}
                                >
                                    <QrCodeSVGComponent
                                        className="qr-code"
                                        size={100}
                                        value={qrCodeShortUrls[promotion.id]}
                                    />
                                    <span
                                        className={classNames(
                                            'qr-code-prompt',
                                            `qr-code-prompt-${
                                                promotion.isPromptTextOnDarkBackground
                                                    ? 'light'
                                                    : 'dark'
                                            }-text`
                                        )}
                                    >
                                        {promotion.promptText}
                                    </span>
                                </div>
                            )}
                            <img className="promo-img" src={promotion.imageUrl} alt="..." />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <div className="promo-pagination" />
        </div>
    );
};

LocationPromotions.propTypes = {
    promotions: PropTypes.array,
    navigate: PropTypes.func.isRequired,
    setJourneyStop: PropTypes.func.isRequired,
    tenantFeatures: PropTypes.array.isRequired,
    digitalSignId: PropTypes.string,
};

export default LocationPromotions;
